export const educationIntakeYears = () => {
    const currentYear = new Date().getFullYear()
    const years: string[] = Array.from(
        { length: currentYear - 1990 + 1 },
        (_, i) => (currentYear - i).toString()
    )
    years.push('Pre-1990')
    return years
}
